export const RetailerApi_Endpoint = {
    //Dashboard3.js
    GET_USER_BUSINESS: `/api/User/v1.0/getUserBusiness`,
    GET_LINE_CHART_DATA_DAILY: `/api/Apitranxt/get_line_chart_data_daily`,
    GET_LINE_CHART_DATA_HOURLY: `/api/Apitranxt/get_line_chart_data_Hourly`,
    GET_LINE_CHART_DATA_WEEKLY: `/api/Apitranxt/get_line_chart_data_weekly`,
    GET_LINE_CHART_DATA_MONTHLY: `/api/Apitranxt/get_line_chart_data_monthly`,
    GET_USER_NOTIFICATION: `/api/Apitranxt/user/get_user_notifications`,
    GET_WALLET_MOVEMENT: `/api/Apitranxt/get_wallet_movement`,
    GET_DASHBOARD_EARNING: `/api/Apitranxt/get_dashboard_earning`,
    GET_LAST_FIVE_TRANSACTION: `/api/Apitranxt/get_last_five_transactions`,
    GET_LAST_FIVE_AEPS_TRANSACTIONS: `/api/Apitranxt/get_last_five_aeps_transactions`,
    GET_LAST_FIVE_BBPS_TRANSACTIONS: `/api/Apitranxt/get_last_five_bbps_transactions`,
    GET_USER_ACCESS_INFO: `/api/Apitranxt/user/get_user_access_info`,
    ADD_SESSION: `/api/Apitranxt/add_session`,

    //AccountLocked.jsx
    AGENT_LOGIN_MOBILE: `/api/User/v1.0/agentLoginMobile`,
    //chaafo.js
    GET_AGENT_LEADS: `/api/User/getAgentLeads`,
    //chaafoForm.js
    SUBMIT_AGENT_LEADS: `/api/User/submitAgentLeads`,

    UPLOAD_LEAD_DOCS: `/uploadLeadDocs.php`,
    SUBMIT_AGENT_LEADS_DOCS: `/api/User/submitAgentLeadsDocs`,
    FLIGHT_WALLET_TOP_UP: `/api/Payment/v1.0/flightWalletTopup`,
    GET_DASHBOARD_TRANSACTION_REPORT: `/api/Apitranxt/get_dashboard_transaction_report`,
    GET_PENDING_TRANSACTION: `/api/Report/GetPendingTransactions`,
    GET_PAYN_NOW_AGENT_ID: `/api/Apitranxt/user/get_paynnow_agentid`,



    //DigiPaymentSystem.js
    DIGI_KHATA_GENERATE_LOGIN_OTP: `/api/DigiKhata/v1.0/generateLoginOtp`,
    DIGI_KHATA_VALIDATE_LOGIN_OTP: `/api/DigiKhata/v1.0/validateLoginOtp`,

    //DigiAccountList.js
    DIGI_KHATA_ADD_BENEFICIARY: `/api/DigiKhata/v1.0/addBeneficiary`,
    GET_ALL_PG_SETTLEMENT_ACCOUNTS: `/api/Payment/pg/getAllPGSettlementAccounts`,
    BANK_ACCOUNT_VERIFY: `/api/Verify/BankaccountVerify`,
    DIGI_KHATA_GET_BENEFICIARY_LIST: `/api/DigiKhata/v1.0/getBeneficiaryList`,
    GET_SETTLEMENT_BANKS: `/api/Settlement/v1.0/getSettlementBanks`,
    DIGI_KHATA_GENERATE_AADHAAR_VERIFY_OTP: `/api/DigiKhata/v1.0/generateAadhaarVerifyOtp`,
    DIGI_KHATA_VALIDATE_AADHAAR_VERIFY_OTP: `/api/DigiKhata/v1.0/validateAadhaarVerifyOtp`,
    DIGI_KHATA_PAN_VERIFY: `/api/DigiKhata/v1.0/panVerify`,
    MERCHANT_PAYMENT_PAY: `/api/Payment/merchant/merchantPaymentPay`,
    DIGI_KHATA_FUND_TRANSFER_SEND_OTP: `/api/DigiKhata/v1.0/fundTransferSendOtp`,
    DIGI_KHATA_FUND_TRANSFER: `/api/DigiKhata/v1.0/fundTransfer`,
    GET_BENEFICIARY_BY_ACCNO: `/api/Apitranxt/get_beneficiary_by_accno`,
    GET_BANK_LIST_DMT: `/api/DMT/Bankit/Main/getBankListDmt`,


    //VendorPaymentSystem.js
    GET_MERCHANT_LIST: `/api/Payment/merchant/getMerchantList`,
    PAYMENT_ADD_MERCHANT: `/api/Payment/merchant/addMerchant`,
    PAYMENT_GET_WALLET_BALANCE: `/api/Payment/wallet/getWalletBalance`,
    ADD_VENDOR: `/api/Vendor/v1.0/addVendor`,
    ADD_VENDOR_RESEND_OTP: `/api/Vendor/v1.0/addVendorResendOtp`,
    ADD_VENDOR_VERIFY: `/api/Vendor/v1.0/addVendorVerify`,

    //VendorAccountList.js
    ADD_MERCHANT_ACCOUNT: `/api/Payment/merchant/addMerchantAccount`,
    DELETE_MERCHANT_ACCOUNT: `/api/Payment/merchant/deleteMerchantAccount`,
    BANK_VERIFICATION: `/api/Verification/bankVerification`,
    ADD_BANK_VENDOR_SEND_OTP: `/api/Payment/addBankVendor/SendOtp`,
    GET_MERCHANT_ACCOUNT: `/api/Payment/merchant/getMerchantAccount`,
    VENDOR_PAYMENTS: `/api/Payment/VendorPayments/vendorPaymentTransactionInitiate`,

    //Aeps7.js --- Aeps2.js

    AEPS_KYC_UPDATE: `/api/AEPS/Aepskycupdate`,
    UPDATE_KYC_STATUS: `/api/Apitranxt/kyc/updatekycstatus`,
    GET_KYC_STATUS: `/api/Apitranxt/getkycstatus`,
    SEND_OTP_DEVICE: `/sendotp.php?device=12343535`,
    VALIDATE_OTP_DEVICE: `/validateOTP.php?device=12343535`,
    FETCH_NEW_TRANSACTION_AEPS: `/api/Apitranxt/fetchnewtransactionaeps`,
    GET_ALL_AEPS_TRANSACTIONS: `/api/AEPS/GetallAEPStransactions`,
    GET_AEPS_TWO_FACTOR_STATUS: `/api/Apitranxt/get_aeps_two_factor_status`,
    AEPS_TWO_FACTOR_UPDATE: `/api/Payment/aeps/twoFactorUpdate`,
    FETCH_KYC_DATA: `/api/Apitranxt/kyc/fetchkycdata`,
    AEPS_TWO_FACTOR_CHECK: `/api/Payment/aeps/twoFactorCheck`,
    FINGPAY_GET_LAT_LONG: `/apibumppypay/v1/web/fingpay/getLatLong.php`,
    AEPS_YESBANK_TRANSACTION: `/api/Payment/aeps/yesbank/transaction`,
    AEPS_GENERATE_TOKEN: `/api/AEPS/GenerateToken`,


    //AepsInstaPay.js
    GET_KYC_TWO_FACTOR_STATUS: `/api/AEPS/v1.0/getKycAndTwoFactorStatus`,
    MERCHANT_ONBOARDING_STATUS: `/api/AEPS/v1.0/Instantpay/merchantOnboardingStatus`,
    MERCHANT_ONBOARDING_VALIDATE_OTP: `/api/AEPS/v1.0/Instantpay/merchantOnboardingValidateOtp`,
    GET_USER_VIEW_PROFILE_DETAILS: `/api/Admin/getUserViewProfileDetails`,
    AEPS_TWO_FACTOR: `/api/AEPS/v1.0/Instantpay/aepsTwoFactor`,
    MERCHANT_ONBOARDING_BIOMETRICKYC: `/api/AEPS/v1.0/Instantpay/merchantOnboardingBiometricKyc`,

    //Aeps8.js

    BANK_LIST: `/banklist.php`,
    YESH_BANK_BALANCE_ENQUIRY: `/api/AEPS/yesbank/balanceEnquiry`,
    GET_TWO_FACTOR_STATUS: `/api/AEPS/getTwoFactorStatus`,
    YESH_BANK_TWO_FACTOR: `/api/AEPS/yesbank/twoFactor`,
    YESH_BANK_CASH_WITHDRAWL: `/api/AEPS/yesbank/cashWithdrawl`,
    YESH_BANK_AGENT_BIAUTH: `/api/AEPS/yesbank/agentBiAuth`,
    YESH_BANK_MINI_STATEMENT: `/api/AEPS/yesbank/miniStatement`,
    GET_YESH_BANK_LIST: `/api/AEPS/yesbank/getBankList`,
    USER_SUBMIT_SERVICE_REQUEST: `/api/User/submitServiceRequest`,
    GET_SERVICES_REQUEST_LIST: `/api/Payment/services/getServicesRequestList`,
    //AepsBankit.js
    EPAN_AUTHENTICATE: `/api/Services/EPAN/authenticate`,
    BANKIT_MAIN_GENERATE_URL: `/api/CMS/Bankit/Main/generateUrl`,
    AEPS_BANKIT_MAIN_GENERATE_URL: `/api/AEPS/Bankit/Main/generateUrl`,

    //ODDocSubmit.js
    PAYMENT_IMAGE_UPLOAD: `/api/Payment/imageUpload`,
    ADMIN_OD_REQUEST_DOC_SUBMIT: `/api/Payment/admin/admininODRequestDocSubmit`,
    GET_ALL_USER_LIST_ADMIN: `/api/Apitranxt/admin/get_all_user_list_admin`,
    SUBMIT_CREDIT_REQUEST: `/api/Payment/credit/submitCreditRequest`,
    UPI_SETTLEMENT: `/api/Settlement/v1.0/UPI/Settlement`,
    UPI_SETTLEMENT_AEPS: `/api/Payment/aeps/upiSettlementAeps`,
    GET_ALL_UP_BENEFICIARY: `/api/Payment/aeps/getAllUpiBeneficiary`,
    TO_UP_AEPS_LIMIT: `/api/Payment/wallet/topupAepsLimit`,
    AEPS_SETTLEMENT: `/api/Settlement/v1.0/AEPS/AadhaarEnabledPaymentSystemSettlement`,
    AEPS_V1_SETTLEMENT: `/api/Payment/aeps/v1/aepsSettlement`,
    GET_USER_BANK_ACCOUNT: `/api/Apitranxt/getuserbankaccount`,

    GET_USER_BANK_ACCOUNT_LIST: `/api/Apitranxt/GetuserBankaccountlist`,
    ADD_BANK_SEND_OTP: `/api/Apitranxt/addBank/SendOtp`,
    PG_SETTLEMENT: `/api/Settlement/v1.0/PG/PaymentGatewaySettlement`,
    PG_SETTLEMENT_V2: `/api/Payment/pg/pgSettlementV2`,
    ADD_BANK_ACCOUNT_PG_SETTLEMENT: `/api/Payment/pg/addBankAccountPGSettlement`,
    GET_VERIFIED_CREDIT_DETAILS: `/api/Payment/credit-card/getVerifiedCreditCardDetails`,
    GET_ALL_TICKET_LIST_ADMIN: `/api/Payment/support/getAllTicketListAdmin`,
    GET_ALL_FAQ_LIST: `/api/Apitranxt/get_all_faq_list`,
    SUBMIT_RAISE_TICKET: `/api/Payment/support/submitRaiseTicket`,
    GET_ALL_SERVICES_ADMIN: `/api/Apitranxt/get_all_services_admin`,
    GET_ALL_OPERATORS: `/api/Operator/GetAllOperators`,
    GET_ALL_OFFILINE_OPERATORS: `/api/Operator/GetAllOfflineOperators`,
    OPERATOR_GET_STATE: `/api/Operator/GetState`,
    ACCOUNT_LOGIN: `/api/Account/Login`,
    GET_LAST_AGENT_ID: `/api/kyc/GetlastAgentid`,
    KYC_CREATE_AGENT: `/api/kyc/CreateAgent`,
    KYC_OTP_VALIDATION: `/api/kyc/OTPValidation`,
    KYC_GET_AADHAAR_WADH: `/api/kyc/GetAadhaarWadh`,
    KYC_AADHAAR_BIOMETRIC_AGENT: `/api/kyc/AadhaarBiometricKYCAgent`,
    EKYC_CODE_UPDATE: `/pi/Apitranxt/kyc/Ekyccodeupdate`,
    PAY_CREDIT_CARD_BILL: `/api/Payment/payCreditCardBillV1`,
    GET_ALL_CREDIT_CARD_BANKS: `/api/Payment/getAllCreditCardBanks`,
    GET_COMMISSION_CHART: `/api/Apitranxt/get_commision_chart`,
    PAYMENT_SERVICES_REQUEST_SUBMIT: `/api/Payment/services/serviceRequestSubmit`,

    //MarconDoc.js
    GET_ALL_KYC_REVIEW_REPORT_ADMIN: `/api/Payment/admin/getAllKycReviewReportAdmin`,

    //RetailerBusiness.js

    GET_USER_DASHBOARD_DATA: `/api/User/getDashboardData`,
    PG_CONCERN_UPLOAD: `/api/Payment/credit-card/pgConcernUpload`,
    CREDIT_CARD_DETAILS_SAVE: `/api/Payment/credit-card/creditCardDetailsSave`,
    CHECK_CREDIT_CARD_VERIFIED: `/api/Payment/credit-card/checkCreditCardVerified`,
    SEND_AADHAR_OTP: `/api/Verify/aadharotpsend`,
    VERIFY_AADHAR_OTP_SEND: `/api/Verify/aadharotpverify`,
    AADHAR_VERIFY_PRO: `/api/Verify/aadharverifypro`,

    BILLER_BILL_PAY_OFFILINE: `/api/Biller/BillPayOffline`,
    BILLER_BILL_FETCH_OFFILINE: `/api/Biller/BillFetchOffline`,

    GET_BBPS_ALL_OFFLINE_OPERATORS: `/api/Payment/bbps/getAllOfflineOperators`,
    CHECK_PASSWORD: `/api/Apitranxt/checkpassword`,
    UPDATE_PWD: `/api/Apitranxt/updatepwd`,
    BBPS_BILL_PAY_OFFLINE: `/api/BBPS/billPayOffline`,
    BBPS_GET_ALL_RECHARGE_PLANS: `/api/BBPS/getAllRechargePlans`,
    GET_RETAILER_BBPS_REPORT: `/api/Apitranxt/get_retailer_bbps_report`,
    GET_LOAD_BANK: `/api/Apitranxt/getloadbank`,
    GENERATE_QRCODE_AUBANK: `/api/Virtual/generateQrCodeAuBank`,
    GET_QRCODE_AUBANK: `/api/Virtual/getQrCodeAuBank`,
    CREATE_LOAD: `/api/Apitranxt/createload`,
    GENERATE_UPI_INTENT: `/api/Virtual/v1.0/generateUpiIntent`,
    PG_GENERATE_GATEWAY_CHARGES: `/api/Payment/pg/getPaymentGatewayCharges`,
    GET_ALL_FUND_SETTLEMENT_PANS: `/api/Payment/fund/getAllFundSettlementPlans`,
    GET_CREDIT_CARD_DETAILS: `/agent_concern/v1/getCreditCardDetails.php`,
    UPLOAD_AADHAR_DOCS: `/agent_concern/v1/uploadAadhaarDocs.php`,
    PG_GET_KYC_STATUS: `/api/PG/getKycStatus`,
    GET_SAVED_BILL_DETAILS: `/api/BBPS/getSavedBillDetails`,
    GET_CREDIT_CARD_STATUS: `/config/v1/getCreditCardStatus.php`,
    UPLOAD_CREDIT_CARD_IMAGE: `/config/v1/uploadCreditCardImages.php`,


    //myPorfile.js
    RESET_USER_TPIN: `/api/User/v1.0/resetUserTpin`,
    RESET_USER_MPIN: `/api/User/v1.0/resetUserMpin`,
    PARENT_FUND_REQUEST_LIST: `/api/Apitranxt/user/parent_fund_request_list`,
    GET_USER_CONFIG_SETTING: `/api/Payment/getUserConfigSettings`,
    USER_CONFIG_SETTING_UPDATE: `/api/Payment/userConfigSettingsUpdate`,
    GET_RETAILER_PROFILE_DETAILS: `/api/Apitranxt/get_retailer_profile_details`,
    DIST_WALLET_CHECK_NUMBER: `/api/Apitranxt/distributor/dist_wallet_to_wallet_chk_number`,
    DIST_WALLET_SUBMIT: `/api/Apitranxt/distributor/dist_wallet_to_wallet_submit`,
    GET_WALLET_REPORT: `/api/Apitranxt/get_wallet_to_wallet_report`,
    KYC_CREATE_CUSTOMER: `/api/kyc/CreateCustomer`,
    AADHAR_BIOMETRIC_KYC_CUSTOMER: `/api/kyc/AadhaarBiometricKYCCustomer`,

    //login5.js
    AGENT_LOGIN_VALIDATE_OTP: `/api/User/v1.0/agentLoginValidateOtp`,
    AGENT_LOGIN_MOBILE_V2: `/api/User/v2.0/agentLoginMobile`,
    AGENT_LOGIN_SEND_OTP: `/api/User/v1.0/agentLoginSendOtp`,
    FORGET_PASSWORD: `/api/User/v1.0/forgetPassword`,
    FORGET_PASSWORD_SEND_OTP: `/api/User/v1.0/forgetPasswordSendOtp`,























































































































}